// extracted by mini-css-extract-plugin
export var mailingListSignupForm = "mailinglistsignup-module--mailing-list-signup-form--Vlqge";
export var mailingListSignupWrapper = "mailinglistsignup-module--mailing-list-signup-wrapper--ahSG9";
export var mailingListSubmissionFailure = "mailinglistsignup-module--mailing-list-submission-failure--3k-eQ";
export var mailingListSubmissionSuccess = "mailinglistsignup-module--mailing-list-submission-success--aUq7l";